const GET_SENRO_CODE_LIST = 'GET_SENRO_CODE_LIST';
const SET_SENRO_CODE_LIST = 'SET_SENRO_CODE_LIST';
export default {
  /** 線路コード一覧 取得 */
  GET_SENRO_CODE_LIST,
  SET_SENRO_CODE_LIST,
};

